module.exports = __webpack_public_path__ + "static/img/wavm8s-2018-end-of-year-edition.3804a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-2018-end-of-year-edition.png
// module id = 07Kb
// module chunks = 0